import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { T } from 'shared/helper/translate';
import Popover from 'researcher/components/Popover';
var RubriqPlagiarismStatus = function RubriqPlagiarismStatus(_ref) {
  var _ref$isNoEditsMessage = _ref.isNoEditsMessage,
    isNoEditsMessage = _ref$isNoEditsMessage === void 0 ? false : _ref$isNoEditsMessage;
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-2 flex-md-row gap-md-3 ".concat(isNoEditsMessage ? 'align-items-center' : 'align-items-start align-items-md-center')
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-2"
  }, /*#__PURE__*/React.createElement(Popover, {
    content: "supported_files",
    "data-bs-toggle": "tooltip",
    "data-bs-placement": "bottom"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-light fa-circle-info"
  }))), /*#__PURE__*/React.createElement(T, {
    source: "file_type_file_size"
  }));
};
export default RubriqPlagiarismStatus;